import React from 'react';

const toneMap = {
  neutral: 'bg-slate-100 text-slate-700 border-slate-200',
  primary: 'bg-primary-50 text-primary-800 border-primary-200',
  secondary: 'bg-secondary-50 text-secondary-800 border-secondary-200',
  success: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  warning: 'bg-amber-50 text-amber-800 border-amber-200',
  danger: 'bg-rose-50 text-rose-700 border-rose-200',
  info: 'bg-sky-50 text-sky-700 border-sky-200',
};

const sizeMap = {
  xs: 'text-[10px] px-2 py-0.5 rounded-md',
  sm: 'text-xs px-2.5 py-0.5 rounded-md',
  md: 'text-sm px-3 py-1 rounded-lg',
};

export const Badge = ({
  children,
  tone = 'neutral',
  size = 'sm',
  dot = false,
  className = '',
  ...props
}) => {
  return (
    <span
      className={`inline-flex items-center gap-1.5 font-medium border ${toneMap[tone] || toneMap.neutral} ${sizeMap[size] || sizeMap.sm} ${className}`}
      {...props}
    >
      {dot && (
        <span
          className={`w-1.5 h-1.5 rounded-full ${
            tone === 'success' ? 'bg-emerald-500'
            : tone === 'warning' ? 'bg-amber-500'
            : tone === 'danger' ? 'bg-rose-500'
            : tone === 'info' ? 'bg-sky-500'
            : tone === 'primary' ? 'bg-primary-600'
            : tone === 'secondary' ? 'bg-secondary-600'
            : 'bg-slate-500'
          }`}
          aria-hidden="true"
        />
      )}
      {children}
    </span>
  );
};

export default Badge;
